import { openModal } from '@core/components/ModalStack';
import { MoveFilesModalProps } from './MoveFilesModal';

export async function openMoveFiles(props: MoveFilesModalProps) {
  const { MoveFilesModal } = await import('./MoveFilesModal');

  openModal(MoveFilesModal, props);
}
